import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { TodoInitialDataService } from '../services/todo-initial-data.service';
import { TodoService } from '../services/todo-service.service';

@Injectable({
  providedIn: 'root'
})
export class TodoResolver implements Resolve<any> {
  constructor(private todoService: TodoService, private todoInitialDataService: TodoInitialDataService) {}

  resolve(): Observable<any> {
    return this.todoService.getConfigurationStatus().pipe(
      tap(data => this.todoInitialDataService.setTodoData(data))
    );
  }
}
